import { ProgramDetails } from "../pages/Registration";
import { getItemInLocalStorage } from "../services/localStorage";
import { contentDateFormat, extractTime } from "../utils/commonFunctions";

export const times = [
  "12:00 AM",
  "12:05 AM",
  "12:10 AM",
  "12:15 AM",
  "12:20 AM",
  "12:25 AM",
  "12:30 AM",
  "12:35 AM",
  "12:40 AM",
  "12:45 AM",
  "12:50 AM",
  "12:55 AM",
  "01:00 AM",
  "01:05 AM",
  "01:10 AM",
  "01:15 AM",
  "01:20 AM",
  "01:25 AM",
  "01:30 AM",
  "01:35 AM",
  "01:40 AM",
  "01:45 AM",
  "01:50 AM",
  "01:55 AM",
  "02:00 AM",
  "02:05 AM",
  "02:10 AM",
  "02:15 AM",
  "02:20 AM",
  "02:25 AM",
  "02:30 AM",
  "02:35 AM",
  "02:40 AM",
  "02:45 AM",
  "02:50 AM",
  "02:55 AM",
  "03:00 AM",
  "03:05 AM",
  "03:10 AM",
  "03:15 AM",
  "03:20 AM",
  "03:25 AM",
  "03:30 AM",
  "03:35 AM",
  "03:40 AM",
  "03:45 AM",
  "03:50 AM",
  "03:55 AM",
  "04:00 AM",
  "04:05 AM",
  "04:10 AM",
  "04:15 AM",
  "04:20 AM",
  "04:25 AM",
  "04:30 AM",
  "04:35 AM",
  "04:40 AM",
  "04:45 AM",
  "04:50 AM",
  "04:55 AM",
  "05:00 AM",
  "05:05 AM",
  "05:10 AM",
  "05:15 AM",
  "05:20 AM",
  "05:25 AM",
  "05:30 AM",
  "05:35 AM",
  "05:40 AM",
  "05:45 AM",
  "05:50 AM",
  "05:55 AM",
  "06:00 AM",
  "06:05 AM",
  "06:10 AM",
  "06:15 AM",
  "06:20 AM",
  "06:25 AM",
  "06:30 AM",
  "06:35 AM",
  "06:40 AM",
  "06:45 AM",
  "06:50 AM",
  "06:55 AM",
  "07:00 AM",
  "07:05 AM",
  "07:10 AM",
  "07:15 AM",
  "07:20 AM",
  "07:25 AM",
  "07:30 AM",
  "07:35 AM",
  "07:40 AM",
  "07:45 AM",
  "07:50 AM",
  "07:55 AM",
  "08:00 AM",
  "08:05 AM",
  "08:10 AM",
  "08:15 AM",
  "08:20 AM",
  "08:25 AM",
  "08:30 AM",
  "08:35 AM",
  "08:40 AM",
  "08:45 AM",
  "08:50 AM",
  "08:55 AM",
  "09:00 AM",
  "09:05 AM",
  "09:10 AM",
  "09:15 AM",
  "09:20 AM",
  "09:25 AM",
  "09:30 AM",
  "09:35 AM",
  "09:40 AM",
  "09:45 AM",
  "09:50 AM",
  "09:55 AM",
  "10:00 AM",
  "10:05 AM",
  "10:10 AM",
  "10:15 AM",
  "10:20 AM",
  "10:25 AM",
  "10:30 AM",
  "10:35 AM",
  "10:40 AM",
  "10:45 AM",
  "10:50 AM",
  "10:55 AM",
  "11:00 AM",
  "11:05 AM",
  "11:10 AM",
  "11:15 AM",
  "11:20 AM",
  "11:25 AM",
  "11:30 AM",
  "11:35 AM",
  "11:40 AM",
  "11:45 AM",
  "11:50 AM",
  "11:55 AM",
  "12:00 PM",
  "12:05 PM",
  "12:10 PM",
  "12:15 PM",
  "12:20 PM",
  "12:25 PM",
  "12:30 PM",
  "12:35 PM",
  "12:40 PM",
  "12:45 PM",
  "12:50 PM",
  "12:55 PM",
  "01:00 PM",
  "01:05 PM",
  "01:10 PM",
  "01:15 PM",
  "01:20 PM",
  "01:25 PM",
  "01:30 PM",
  "01:35 PM",
  "01:40 PM",
  "01:45 PM",
  "01:50 PM",
  "01:55 PM",
  "02:00 PM",
  "02:05 PM",
  "02:10 PM",
  "02:15 PM",
  "02:20 PM",
  "02:25 PM",
  "02:30 PM",
  "02:35 PM",
  "02:40 PM",
  "02:45 PM",
  "02:50 PM",
  "02:55 PM",
  "03:00 PM",
  "03:05 PM",
  "03:10 PM",
  "03:15 PM",
  "03:20 PM",
  "03:25 PM",
  "03:30 PM",
  "03:35 PM",
  "03:40 PM",
  "03:45 PM",
  "03:50 PM",
  "03:55 PM",
  "04:00 PM",
  "04:05 PM",
  "04:10 PM",
  "04:15 PM",
  "04:20 PM",
  "04:25 PM",
  "04:30 PM",
  "04:35 PM",
  "04:40 PM",
  "04:45 PM",
  "04:50 PM",
  "04:55 PM",
  "05:00 PM",
  "05:05 PM",
  "05:10 PM",
  "05:15 PM",
  "05:20 PM",
  "05:25 PM",
  "05:30 PM",
  "05:35 PM",
  "05:40 PM",
  "05:45 PM",
  "05:50 PM",
  "05:55 PM",
  "06:00 PM",
  "06:05 PM",
  "06:10 PM",
  "06:15 PM",
  "06:20 PM",
  "06:25 PM",
  "06:30 PM",
  "06:35 PM",
  "06:40 PM",
  "06:45 PM",
  "06:50 PM",
  "06:55 PM",
  "07:00 PM",
  "07:05 PM",
  "07:10 PM",
  "07:15 PM",
  "07:20 PM",
  "07:25 PM",
  "07:30 PM",
  "07:35 PM",
  "07:40 PM",
  "07:45 PM",
  "07:50 PM",
  "07:55 PM",
  "08:00 PM",
  "08:05 PM",
  "08:10 PM",
  "08:15 PM",
  "08:20 PM",
  "08:25 PM",
  "08:30 PM",
  "08:35 PM",
  "08:40 PM",
  "08:45 PM",
  "08:50 PM",
  "08:55 PM",
  "09:00 PM",
  "09:05 PM",
  "09:10 PM",
  "09:15 PM",
  "09:20 PM",
  "09:25 PM",
  "09:30 PM",
  "09:35 PM",
  "09:40 PM",
  "09:45 PM",
  "09:50 PM",
  "09:55 PM",
  "10:00 PM",
  "10:05 PM",
  "10:10 PM",
  "10:15 PM",
  "10:20 PM",
  "10:25 PM",
  "10:30 PM",
  "10:35 PM",
  "10:40 PM",
  "10:45 PM",
  "10:50 PM",
  "10:55 PM",
  "11:00 PM",
  "11:05 PM",
  "11:10 PM",
  "11:15 PM",
  "11:20 PM",
  "11:25 PM",
  "11:30 PM",
  "11:35 PM",
  "11:40 PM",
  "11:45 PM",
  "11:50 PM",
  "11:55 PM",
];

export const durations = [
  "15m",
  "30m",
  "45m",
  "01h",
  "01h 15m",
  "01h 30m",
  "01h 45m",
  "02h",
  "02h 15m",
  "02h 30m",
  "02h 45m",
  "03h",
  "03h 15m",
  "03h 30m",
  "03h 45m",
  "04h",
  "04h 15m",
  "04h 30m",
  "04h 45m",
  "05h",
  "05h 15m",
  "05h 30m",
  "05h 45m",
  "06h",
  "06h 15m",
  "06h 30m",
  "06h 45m",
  "07h",
  "07h 15m",
  "07h 30m",
  "07h 45m",
  "08h",
  "08h 15m",
  "08h 30m",
  "08h 45m",
  "09h",
  "09h 15m",
  "09h 30m",
  "09h 45m",
  "10h",
];

export const SOCKET_CONFIG = {
  URL: process.env.REACT_APP_SOCKET_URL,
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 2000,
  AUTO_CONNECT: false,
  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",
};

// Socket Events
export const SOCKET_EVENTS = {
  // Connection events
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  CONNECT_ERROR: "connect_error",
  CONNECT_FAILED: "connect_failed",
  RECONNECT: "reconnect",
  RECONNECTING: "reconnecting",
  RECONNECT_ERROR: "reconnect_error",
  RECONNECT_FAILED: "reconnect_failed",
  ERROR: "error",

  // Custom events
  REGISTER_USER: "registerUser",
  WEBINAR_DATA: "webinarData",
};

export const RETRY_FAILED = "retryFailed"; // custom emit event

export const DEFAULT_POLLING_INTERVAL = "5000"; // 1 minute

export const POLLING_TIME_LIMIT = 5000;

export const TOKEN_EXPIRED_MESSAGE =
  "Internal server error during authentication.";

export const WEBINAR_ENDED = "WEBINAR ENDED";

export const SCROLL_PAGINATION = {
  PAGE_SIZE: 25,
};

export const APP_DETAILS = {
  APP_TYPE: "infinipath",
  APP_VERSION: "1.0.0",
};

export const INVITE_FLAG = {
  ACCEPT: "accept",
  VERIFY: "verify",
};

export const MESSAGE = {
  MEMBER_ALREADY_VERIFIED: "Member is already verified",
  MEMBER_ALREADY_DELETED: "Member has already been deleted",
  MEMBER_DELETED: "Member request is already deleted",
};

// Retrieve and process configurations from localStorage
const rawConfigurations = getItemInLocalStorage("appConfigurations");
const parsedConfigurations = rawConfigurations
  ? JSON.parse(rawConfigurations)
  : [];

// Create constants dynamically based on the key-value pairs
export const CONFIGURATIONS = parsedConfigurations.reduce(
  (acc: unknown, item: unknown) => {
    acc[item.key] = item.value;
    return acc;
  },
  {},
);
console.log(CONFIGURATIONS.joinMarkAttendance, "CONFIGURATIONS");
// Example: Create specific constants for easier access
export const FACIAL_RECOGNITION = CONFIGURATIONS.facialRecognition || true;
export const PREFERENCE = CONFIGURATIONS.preference || true;
export const ENABLE_JOIN_WITH_OTHERS = CONFIGURATIONS.joinWithOthers || true;
export const ADD_MEMBERS = CONFIGURATIONS.addMembers || true;
export const JOIN_MARK_ATTENDANCE = CONFIGURATIONS.joinMarkAttendance || true;
export const JOIN_OTP_VERIFICATION =
  CONFIGURATIONS.joinOtpVerification || false;
export const JOIN_MEETING_THROUGH_ZOOM  =  CONFIGURATIONS.enableZoomRedirection || true;

export const errorMessages = {
  firstNameRequired: "Please enter your First name",
  legalNameRequired: "Please enter your Full name",
  firstNameInvalid: "First name must not contain numbers or special characters",
  firstNameMaxLength: "First name must not exceed 30 characters",
  legalNameMaxLength: "Full name must not exceed 30 characters",
  lastNameRequired: "Please enter your Last name",
  lastNameInvalid: "Last name must not contain numbers or special characters",
  lastNameMaxLength: "Last name must not exceed 30 characters",
  emailRequired: "Please enter your email address",
  emailInvalid: "Please enter a valid email address",
  cityRequired: "Please enter your Location",
  otherCityRequired: "Please enter Other city name",
  phoneRequired: "Please enter valid mobile number",
  phoneNumberNotMatch: "The entered mobile number does not match your account",
  dobRequired: "Date of birth is required",
  dobInvalid: "Please enter a valid Date of birth",
  dobAgeRange: "Age must be between 3 and 100 years",
  genderRequired: "Please select Gender",
  invalidEmail: "Please enter a valid email address",
};

export const textConstants = {
  countryCode: "IN",
  withoutVerificationText: "mark attendance without verification",
  withoutVerificationTextStatus: "marked attendance without verification",
  skipFaceVerificationStatus: "attendance marked but not verified",
  attendanceText: "marked attendance with verification",
  markAttendanceWithFace: "with Face ID verification",
  markAttendanceWithoutFace: "without Face ID verification",
  markAttendanceWithOtp: "mark attendance using OTP",
  usingFaceId: "verify using Face ID",
  usingOtp: "verify using OTP",
  usingSkip: "skip for now",
  invalidCodeFirebaseText: "auth/invalid-verification-code",
  sessionExpiredFirebaseText: "auth/code-expired",
  code39: "auth/error-code:-39",
  invalidCodeText: "Invalid OTP. Please enter the one we sent",
  sessionCodeText: "The OTP has expired. Tap 'resend OTP' to get a new one",
  code39Text: "The OTP has expired. Tap 'resend OTP' to get a new one",
  unableValidateFace: "Sorry, we are unable to validate your Face ID",
  cameraNotAccess: "We need access to your camera. Please allow it in browser settings.", //pop up
  largeImageFile:
    "Image is too large even after compression. Please try again.",
  unableCaptureImage: "Error: Unable to capture image.",
  multipleFaceDetected: "Multiple faces detected",
  deviceSettingAccess:
    "We couldn't access your camera. Please check your device settings or login using different device",
  loginfailedFace: "Login failed, please try with OTP",
  skipNowText: "skip for now",
  tryAgainText: "try again",
  okayText: "okay",
  askFaceSetUp: "Please setup your Face ID",
  faceNotMatch: "Face ID did not match",
  faceMatch: "Successfully updated",
  infinipathRedirectText:
    "Please wait, you are being redirected to infinipath…",
  faceMatchesExist: "Face ID matches with existing an Face ID",
  unableToSetFaceId: "Sorry, we are unable to setup your Face ID",
  skipUnverifiedText: "By clicking skip, you will be marked as ‘unverified’",
  errorText: "Error",
  succesText: "Success",
  unsubscribeText: "Verify your mobile number to delete account",
  unsubscribeMobileText: "Registered mobile number",
  confirmOtpText: "Confirm OTP",
  didntReceiveText: "Didn't receive an OTP?",
  stayTunedText: "Stay tuned for further updates",
  phoneNumberErrorText: "Please enter valid mobile number",
  verifiedSuccessText: "Member verified successfully",
  updatedSuccessfully: "Successfully updated the data",
  joinAsGroupText: "joining as a group",
  joinAloneText: "joining alone",
  myGroupMembersText: "My group members",
  myGroupText: "MY GROUP",
  unableToFindSeekers: "Unable to find seeker",
  searchSeekerPlaceholder: "search seekers",
  changeMobileText: "change your mobile number",
  signInWithface: "Sign in with Face ID if you have already set it up",
  setUpFace: "setup my Face ID",
  enterOtpSentText: "Enter the OTP sent to",
  markAttandanceAndJoin: "mark attendance and join", 
  meetingJoin: "join",
  signInWithOtp: "sign in using OTP",
  mobileNumber: "Mobile number",
  deleteAccount: "Delete account",
  termsText: "Terms & Conditions",
  privacyText: "Privacy Policy",
  updateProfile: "Update profile",
  withVerification: "with verification",
  withoutVerification: "without verification",
  sectionListText:"This section lists friends/family you've added to your group",
  login: "login",
  joinEnableText: "Join button will be enabled here at",
  countryDefault: "IN",
  serverError: "server_error",
  setUpFaceIdText: "Set up your Face ID in the profile session for verifying attendance",
  areYouSureText: "Are you sure you want to remove",
  fromList: "from your list?",
  faceIdNotSetUp: "Face ID is not set up",
  friendsSectionHeading: "This section lists friends/family you've added to your group",
  invitePendingHeading: "INVITE PENDING",
  mahatriaRole: "mahatria",
  adminRole: "admin",
  joinInfinipathText: "join infinipath",
  addMembersText: "add new member",
  areYouSureToDelete: "Are you sure you want to continue?",
  noInternet: "Oh no! No internet connection",
  notWorkingText: "We’re sorry, something is not working here",
  retryText: "retry",
  byDeletingAccountText:"Deleting your account will revoke",
  deleteAccountText: "access to infinipath and all infinitheism apps (if installed), including your data, progress, and access to exclusive content",
  catchErrorMessage: "Unable to process your request",
  howToVerify: "How do you want to verify?",
  signInusingEmail: "Having trouble?",
  signInusingEmailText: "sign in with your email to get OTP.",
  signInUsingMobile: "Having trouble?",
  signInUsingMobileText: "sign in with your mobile number to get OTP.",
  changeEmailText: "change your email",
  getOtpEmail: "get OTP on email",
  getOtpMobile: "get OTP on mobile",
  attemptsCompleted: "Your attempts are completed. Please try again.",
};

export const LOGIN_TEXT = {
  WELCOME: {
    TEXT: "Welcome to",
  },
  FACE_ID: {
    CAPTION: "capture your face for",
    CAPTION_CONTINUE: "quick authentication",
    SETUP_CAPTION: "Setup Face ID for quick sign in?",
    BUTTONS: {
      SIGN_IN: "sign in using Face ID",
      SIGN_IN_OTP: "sign in using OTP",
      SETUP: "setup Face ID",
      SKIP: "skip for now"
    }
  },
  APP:{
    NAME: "infinipath",
  },
  MOBILE: {
    LABEL: "Mobile number*",
    ENTER_TEXT: "enter your mobile number"
  },
  EMAIL: {
    LABEL: "Email address*",
    ENTER_TEXT: "enter your email address"
  },
  OTP: {
    CONFIRM: "Confirm OTP",
    ENTER: "Enter the OTP sent to",
    CHANGE_MOBILE: "change your mobile number",
    VERIFY: "verify",
    DIDNT_RECEIVE: "Didn't receive?",
    RESEND: "resend OTP",
    RESENDIN: "resend OTP in"
  },
  ERRORS: {
    PHONE_REQUIRED: "Phone number is required",
    INVALID_PHONE: "Invalid phone number",
    USER_NOT_EXIST: "User does not exist, please",
    SIGN_UP: "sign up",
    FETCH_USER: "Failed to fetch user data, please try again later",
    SEND_OTP: "Failed to send the OTP, please try again later",
    UNABLE_TO_SENT: "Unable to send OTP",
    TOO_TEXT: "too",
    MANY_TEXT: "many",
    ERROR_SEND_OTP: "error sending otp",
  },
  BUTTONS: {
    GET_OTP: "get OTP",
    VERIFY: "verify"
  },
  SIGN_IN: {
    WITH_FACE: "sign in using face ID",
    CAPTION_NEW: "Quick & secure sign in with face ID"
  },
  OR: "or",
  CLICK: "Click here to",
  SKIP_FACE_VERIFY: "skipFaceVerify",
  LOGGED_IN: "loggedIn",
  YES: "yes",
  NO: "no",
  SEEKER_DETAILS: "seekerDetails",
  LOGO: "logo",
  SUBMIT: "submit",
  ICON: "icon",
  EMAILSIGNIN: "sign in using email",
  MOBILESIGNIN: "sign in using mobile",
  EMAILPLACEHOLDER: "abc@gmail.com",
} as const;

export const LOCAL_STORAGE_KEYS = {
  TEMP_PROFILE_PICTURE: "tempProfilePicture",
  UNSAVED_PROFILE_DATA: "unsavedProfileData",
  SEEKER_DETAILS: "seekerDetails",
}

export const PENDING_APPROVAL = "pending_approval"
export const WAIT_LIST = "waitlisted"
export const REJECTED = "rejected"
export const BLESS_REJECTED = "bless_rejected"
export const ON_HOLD = "on_hold"
export const APPROVED = "approved"
export const PENDING = "pending"
export const COMPLETED = "completed"
export const PAYMENT_REQUEST = "payment_request"
export const ONLINE_PENDING = "online_pending"
export const ONLINE_COMPLETED = "online_completed"
export const OFFLINE_PENDING = "offline_pending"
export const OFFLINE_COMPLETED = "offline_completed"
export const TRAVEL_PENDING = "travel_pending"
export const SAVE_DRAFT = "save_as_draft"
export const FREE_SEAT = "free_seat"
export const FORM = "form";
export const FAILED = "failed";
export const CANCELLED = "cancelled";
export const OFFLINE = "offline";
export const ONLINE = "online";
export const REQUESTED = "requested";

export const stateGstCodes = [
  { code: '01', state: 'JK', stateName: 'Jammu and Kashmir' },
  { code: '01', state: 'JK', stateName: 'Jammu & Kashmir' },
  { code: '02', state: 'HP', stateName: 'Himachal Pradesh' },
  { code: '03', state: 'PB', stateName: 'Punjab' },
  { code: '04', state: 'CH', stateName: 'Chandigarh' },
  { code: '05', state: 'UK', stateName: 'Uttarakhand' },
  { code: '06', state: 'HR', stateName: 'Haryana' },
  { code: '07', state: 'DL', stateName: 'Delhi' },
  { code: '08', state: 'RJ', stateName: 'Rajasthan' },
  { code: '09', state: 'UP', stateName: 'Uttar Pradesh' },
  { code: '10', state: 'BR', stateName: 'Bihar' },
  { code: '11', state: 'SK', stateName: 'Sikkim' },
  { code: '12', state: 'AR', stateName: 'Arunachal Pradesh' },
  { code: '13', state: 'NL', stateName: 'Nagaland' },
  { code: '14', state: 'MN', stateName: 'Manipur' },
  { code: '15', state: 'MZ', stateName: 'Mizoram' },
  { code: '16', state: 'TR', stateName: 'Tripura' },
  { code: '17', state: 'ML', stateName: 'Meghalaya' },
  { code: '18', state: 'AS', stateName: 'Assam' },
  { code: '19', state: 'WB', stateName: 'West Bengal' },
  { code: '20', state: 'JH', stateName: 'Jharkhand' },
  { code: '21', state: 'OD', stateName: 'Odisha' },
  { code: '22', state: 'CT', stateName: 'Chhattisgarh' },
  { code: '22', state: 'CT', stateName: 'Chattisgarh' },
  { code: '23', state: 'MP', stateName: 'Madhya Pradesh' },
  { code: '24', state: 'GJ', stateName: 'Gujarat' },
  { code: '26', state: 'DD',  stateName: 'Dadra and Nagar Haveli and Daman and Diu'},
  { code: '26', state: 'DD', stateName: 'Dadra & Nagar Haveli'},
  { code: '27', state: 'MH', stateName: 'Maharashtra' },
  { code: '29', state: 'KA', stateName: 'Karnataka' },
  { code: '30', state: 'GA', stateName: 'Goa' },
  { code: '31', state: 'LD', stateName: 'Lakshadweep' },
  { code: '32', state: 'KL', stateName: 'Kerala' },
  { code: '33', state: 'TN', stateName: 'Tamil Nadu' },
  { code: '34', state: 'PY', stateName: 'Puducherry' },
  { code: '34', state: 'PY', stateName: 'Pondicherry' },
  { code: '35', state: 'AN', stateName: 'Andaman & Nicobar' },
  { code: '35', state: 'AN', stateName: 'Andaman and Nicobar Islands' },
  { code: '36', state: 'TG', stateName: 'Telangana' },
  { code: '37', state: 'AP', stateName: 'Andhra Pradesh' },
  { code: '38', state: 'LA', stateName: 'Ladakh' },
  { code: '97', state: 'OT', stateName: 'Other Territory' },
  { code: '99', state: 'CJ', stateName: 'Centre Jurisdiction' },
];


export function pickUpTimings(date: string, type: string, allocatedProgram: ProgramDetails) {
  switch(type){
  case "city pick up travelPlanOnward": return `City Pick-up Time: Buses will depart at 5:00 p.m. from Ratnadeep, East Marredpally, Secunderabad, on ${contentDateFormat(date)}`
  case "city drop travelPlanReturn": return `City Drop Time: Buses will depart from Leonia on ${contentDateFormat(date, true)}, starting 11:45 a.m. onwards in regular intervals to Ratnadeep, East Marredpally, Secunderabad.`
  case "own transport travelPlanOnward": return `Check-in Time: From ${extractTime(allocatedProgram?.checkinAt)} to  ${extractTime(allocatedProgram?.checkinEndsAt)} on ${contentDateFormat(date)}, at Leonia.`
  case "own transport travelPlanReturn": return `Check-out Time: Latest by ${extractTime(allocatedProgram?.checkoutAt)} on ${contentDateFormat(date)}.`
 case "flight travelPlanOnward": return`Airport Pick-up Time: Buses will be available at Hyderabad airport from 3:00 p.m. to 7:00 p.m. on ${contentDateFormat(date)}.`
  case "flight travelPlanReturn": 
  return `Buses will depart from Leonia starting 11:45 a.m. onwards on ${contentDateFormat(date,true)}. in regular intervals to Hyderabad airport.` 
  default:
    return "";
}
}


export function getProgramKeys(bindingKey: string) {
  const programKeys = {
    "city pick up travelPlanOnward": "startsAt",
    "city drop travelPlanReturn": "endsAt",
    "own transport travelPlanOnward": "checkinAt",
    "own transport travelPlanReturn": "checkoutAt",
    "flight travelPlanOnward": "startsAt",
    "flight travelPlanReturn": "endsAt"
  };
  return programKeys[bindingKey] || "";
}

export const VIEW_DETAILS = {
  PROGRAM_NAME: "HDB/MSD",
  PROGRAM_DATES: "Dates",
  INVESTMENT: "Investment",
};

export const WARNING = "warning";
export const SUCCESS = "success";
export const ERROR = "error";
export const INFO = "info";
export const DEFAULT = "default";
export const CANCEL = "cancel";
export const CONFIRM = "confirm";


export const WARNING_MESSAGES = {
  VIDEO_LENGTH_EXCEEDED: ["Your video is too long.","Please upload one that’s 111 seconds or shorter."],
  VIDEO_SIZE_EXCEEDED: ["This video is too large." ,"Try one under 50MB."],
  API_ERROR: ["This action didn’t go through. Please check your details and try again."],
  PAYMENT_ERROR: ["We couldn’t start the payment.Please check your details and try again."],
  PAYMNET_COMPLETED: ["Payment already completed."],
  SOMETHING_WENT_WRONG: ["Something went wrong.", "Try again in a moment."],
  FAILED_TO_EXTRACT: ["Something went wrong.","Failed to extract details from the document."],
  UNSUPPORTED_FILE_TYPE: ["Unsupported file type. Please use JPG, PNG, or similar."],
  IMAGE_SIZE_EXCEEDED: ["This image is too large. Try one under 3MB."],
  IMAGE_PROCESSING_FAILED: ["We couldn't process your image right now.","Please try a different one or reupload."],
  ALREADY_BLESSED: ["You are already blessed for this program."],
  REJECTED:["Your request has been placed with mahatria."],
  NOT_AUTHORIZED: ["You’re logged in with a different account.","Please switch to the one used for this registration."],
  CAMERA_AUDIO_ACCESS_BLOCKED: ["Camera and audio access are blocked.","Please allow access in your browser settings."],
  CAMERA_ACCESS_BLOCKED: ["Camera access is blocked.","Please allow access in your browser settings."],
  AUDIO_ACCESS_BLOCKED: ["Audio access is blocked.","Please allow access in your browser settings."],
  NO_VIDEO_RECORDED: ["No video recorded to submit."],
  PROFILE_UPDATE_FAILED: ["Failed to update profile."],
  UNSUPPORTED_VIDEO_TYPE: ["Unsupported file type. Please use video format."],
  NO_CHANGES_MADE: ["No changes made "],
  REGIISTRATION_CLOSED: ["The Registations are closed."],
  REGIISTRATION_NOT_OPENED: ["The Registations are not opened."],
  REG_CANCELLED: ["Your registration has been cancelled"],
  PAYMENT_DONE : ["You have already completed the payment. Please go to home to view more details"]
};

export const PROGRAM_CARD_MSG = {
  PENDING_APPROVAL: [
        "Thanks for completing your registration.",
        "Your request has now been placed with Mahatria. You can edit your registration until you are blessed with a seat.",
      ],
  ON_HOLD : [
        "Thanks for completing your registration.",
        "Your request has now been placed with Mahatria",
      ],
  REJECTED :  [
    "Thanks for completing your registration.",
    "Your request has now been placed with Mahatria. You can edit your registration until you are blessed with a seat.",
  ],
  FREE_SEAT: [
        "Your seat is confirmed.",
        "Click the Summary button to view your complete registration details anytime.",
      ],
}

export const TOAST_CONFIG = {
  POSITIONS: {
    TOP_RIGHT: "top-right",
    BOTTOM_RIGHT: "bottom-right",
  },
  AUTO_CLOSE: {
    SHORT: 2500,
    LONG: 4000,
  },
  ICON_SIZE: {
    width: 40,
    height: 40,
  },
} as const;


export const SECTION_KEYS = {
  MAHATRIA: "FS_MAHATRIAQUESTIONS",
  BASIC_DETAILS: "FS_BASICDETAILS",
  PAYMENTSECTION: "FS_PAYMENTINVOICE",
  TRAVELSECTION: "FS_TRAVELPLAN"
}

export const STATUS = {
  OPENED: "OPENED",
  CLOSED: "CLOSED", 
  NOT_OPENED: "NOT_OPENED"
}

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const INDIA = "india";
export const AMOUNT_TO_BE_PAID = "Amount to be paid";